import styled, { css, injectGlobal } from 'styled-components';
import { grey300 } from './colors';
import { media } from './utils';

const maxWidth = 1280;

injectGlobal`
    html,
    body {
        margin: 0;
        padding: 0;
        height: 100%;
        width: 100%;
        background: white;
        color: black;
    }

    a {
        text-decoration: none;
    }

    a, p, div {
        color: black;
    }

    em {
        font-family: 'TiemposText-RegularItalic';
    }

    strong, bold {
        font-family: 'TiemposText-Bold';

        & em {
            font-family: 'TiemposText-BoldItalic';
        }
    }
    
    * {
        -webkit-overflow-scrolling: touch;
    }
`;

export const container = css`
    max-width: ${maxWidth}px;
`

export const hoverState = css`
    transition: 0.15s opacity ease;

    &:hover {
        opacity: 0.7;
    }
`

export const padding = css`
    padding-left: 40px; 
    padding-right: 40px;

    ${media.phone`
        padding-left: 32px; 
        padding-right: 32px;
    `}
`

export const line = css`
    width: 100%;
    height: 1px;
    background-color: grey;
    
    margin-bottom: ${props => props.marginBottom ? 55 : 0}px;

    ${media.tablet`
        margin-bottom: ${props => props.marginBottom ? 40 : 0}px;
    `}
`

export const bgImage = css`
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
`

export const bgIcon = css`
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
`

export const indicator = css`

`

export const body = css`
    font-family: 'TiemposText-Regular';
    font-size: 15px;
    color: #4D4D4D;
    letter-spacing: 0;
    line-height: 27px;

    ${media.phone`
        font-size: 14px;
        line-height: 23px;
    `}
`

export const Title = styled.div`
    font-family: 'Platform-Medium';
    font-size: 53px;
    text-align: center;
    color: #B0B0B0;
`



// WEBPACK FOOTER //
// ./client/styles/global.js